class LogHelper {
  static log(context, msg) {
    if (!window.debug) return;
    console.log(`DEBUG: [${context}] ${msg}`);
  }
}

export default LogHelper;
